import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AdminService, AdminFeature } from './services/admin.service';

// Gate the admin area on holding any admin capability.
export const adminGuard: CanActivateFn = () => {
  const adminService = inject(AdminService);
  const router = inject(Router);
  return adminService.ensureCapabilities().pipe(
    map((caps) => {
      if (caps.is_super_admin || caps.features.length > 0) {
        return true;
      }
      return router.createUrlTree(['/search']);
    }),
  );
};

// Per-tab guard requiring a specific feature; falls back to the admin home.
export const adminFeatureGuard =
  (feature: AdminFeature): CanActivateFn =>
  () => {
    const adminService = inject(AdminService);
    const router = inject(Router);
    return adminService.ensureCapabilities().pipe(
      map((caps) => {
        if (caps.is_super_admin || caps.features.includes(feature)) {
          return true;
        }
        return router.createUrlTree(['/admin']);
      }),
    );
  };

/** Super-admin-only guard for the access matrix. */
export const superAdminGuard: CanActivateFn = () => {
  const adminService = inject(AdminService);
  const router = inject(Router);
  return adminService.ensureCapabilities().pipe(
    map((caps) => (caps.is_super_admin ? true : router.createUrlTree(['/admin']))),
  );
};
